import { Component, Input } from '@angular/core';
import * as uuid from 'uuid';

@Component({
  selector: 'eo-base-view',
  templateUrl: './eo-base-view.component.html',
  styleUrl: './eo-base-view.component.css',
})
export class EoBaseViewComponent {
  id: string;
  @Input() label?: string;
  @Input() value?: string | Date;
  @Input() toolTipText?: string;
  @Input() ellipsis: boolean = false;

  constructor() {
    this.id = uuid.v4();
  }

  ngOnInit(): void {}
}
